import { ComponentProps } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import Badge from '../components/shared/Badge';
import { CheckboxOption } from '../model/CheckboxOption';
import { TRANSLATED_CONSTANTS } from '../static/translatedConstants';

// Display-only badge for the listing-type options below. MoreFilter rewrites the
// selected listing options to `{ label: item.value, value: item.value }` before
// the filter leaves the component, so the badge copy never reaches the server and
// is safe to translate. It needs to be a component because `useIntl` can only be
// called from one, and these option arrays live at module scope.
type TypeBadgeProps = {
  theme: ComponentProps<typeof Badge>['theme'];
  message: MessageDescriptor;
};

const TypeBadge = ({ theme, message }: TypeBadgeProps) => {
  const intl = useIntl();
  return <Badge size="sm" theme={theme} label={intl.formatMessage(message)}></Badge>;
};

export const dataTypes: CheckboxOption[] = [
  {
    value: 'storefront',
    label: <TypeBadge theme="purple" message={TRANSLATED_CONSTANTS.STOREFRONT} />
  },
  {
    value: 'storefrontItem',
    label: <TypeBadge theme="indigo" message={TRANSLATED_CONSTANTS.STOREFRONT_ITEMS} />
  },
  {
    value: 'personal',
    label: (
      <TypeBadge
        theme="blue"
        message={{
          id: 'shared.more_filter.personal_listings',
          defaultMessage: 'Personal Listings'
        }}
      />
    )
  },
  {
    value: 'wanted',
    label: <TypeBadge theme="pink" message={TRANSLATED_CONSTANTS.WANTED_LISTING} />
  },
  {
    value: 'event',
    label: <TypeBadge theme="orange" message={TRANSLATED_CONSTANTS.EVENTS} />
  }
];

export const alertnatePriceOptions: CheckboxOption[] = [
  {
    value: 'Negotiable (no price)',
    label: (
      <FormattedMessage
        id="shared.more_filter.negotiable_no_price"
        defaultMessage="Negotiable (no price)"
      />
    )
  },
  {
    value: 'Doge = Doge',
    label: <FormattedMessage id="page.dashboard.doge_doge" defaultMessage="1 Doge = 1 Doge" />
  }
];
export const priceType: CheckboxOption[] = [
  {
    value: 'Price is firm',
    label: <FormattedMessage id="page.dashboard.price_is_firm" defaultMessage="Price is firm" />
  },
  {
    value: 'Open for offers',
    label: <FormattedMessage id="shared.open-for-offers" defaultMessage="Open for offers" />
  }
];

export const defaultConditions: CheckboxOption[] = [
  {
    value: 'Brand new',
    label: <FormattedMessage id="backend.condition.brand_new" defaultMessage="Brand new" />
  },
  {
    value: 'Excellent condition',
    label: (
      <FormattedMessage id="backend.condition.excellent" defaultMessage="Excellent condition" />
    )
  },
  {
    value: 'Fair condition',
    label: <FormattedMessage id="backend.condition.fair" defaultMessage="Fair condition" />
  },
  {
    value: 'Good condition',
    label: <FormattedMessage id="backend.condition.good" defaultMessage="Good condition" />
  }
];
